
<template>
  <div class="top-section">
    <!-- FILTROS -->
    <div class="top-section__filters">
      <Filters
        ref="filtersRef"
        :filtros="filtros"
        section="Top"
      />
    </div>

    <!-- ACCIÓN -->
    <div
      v-if="!(isMobile && leftSectionFiltersLength > 0)"
      class="top-section__action"
    >
      <Button
        :label="leftSectionFiltersLength > 0
          ? 'Aplicar todos los filtros'
          : 'Aplicar filtros'"
        size="small"
        class="apply-filter"
        @click="emit('apply-filters')"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import Button from "primevue/button";
import Filters from "@/pages/_root/views/reports-details/sections/Filters.vue";

const props = defineProps({
  filtros: {
    type: Array,
    required: true,
  },
  leftSectionFiltersLength: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["apply-filters"]);

const filtersRef = ref(null);
const isMobile = ref(window.innerWidth <= 575);

function updateIsMobile() {
  isMobile.value = window.innerWidth <= 575;
}

function getFilters() {
  return {
    filters: props.filtros,
    values: filtersRef.value.values,
    ranges: filtersRef.value.ranges,
  };
}

onMounted(() => {
  window.addEventListener("resize", updateIsMobile);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateIsMobile);
});

defineExpose({ getFilters });
</script>

<style lang="scss" scoped>
@import "@/styles/_vars.scss";

.top-section {
  background-color: #f1f5f9;
  border: 1px solid #e5e7eb;
  padding: 0.35rem 0.35rem 0.25rem;
  border-radius: 8px;
}

.top-section__filters {
  width: 100%;
}

.top-section__action {
  display: flex;
  justify-content: flex-end;
  padding-right: 0.25rem;
  margin-top: 0.15rem;
}

.apply-filter {
  background-color: $primary;
}

@media (max-width: 575px) {
  .top-section__action {
    justify-content: stretch;
    padding-right: 0;
  }

  .apply-filter {
    width: 100%;
  }
}
</style>


